__turbopack_context__.v({
  "container": "HeaderBurgerMenu-module__DpEM-a__container",
  "isActive": "HeaderBurgerMenu-module__DpEM-a__isActive",
});
